import ViewDetails from "../../utils/utilities/ViewDetails";

import { Tab } from "@mui/material";

import ContactPageOutlinedIcon from '@mui/icons-material/ContactPageOutlined';

// Tabs
import GeneralTab from "./Tabs/General";

  const tabContent = [
    {panel: "general", content: <GeneralTab />},
  ]

const ViewPromotion = () => {

  const tabs = [
    {label: "General", icon: <ContactPageOutlinedIcon fontSize="small" />},
  ];

  return (
    <ViewDetails title="SMS Promotion" identifier="sms_promotion_id" tabs={tabs} tabContent={tabContent} url="messages/promotions">

    </ViewDetails>
  )
};

export default ViewPromotion;